import { lazy } from "react";

const Verify = lazy(() => import("@/pages/verify"));

export const verify = [
  {
    path: "/verify",
    component: Verify,
    layout: "decisively-scoped",
    role: "tester",
    exact: true,
  },
];
